var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"easy-btn-container"}},[_c('div',{staticClass:"easy-bg-svg"},[_c('div',{staticClass:"easy-any-text"},[_vm._v(_vm._s(_vm.btnText))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-316429d5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!/var/tomcat/.jenkins/workspace/EasyTitle24/easytitle24-2.x-common/components/easy-btn.vue
// module id = null
// module chunks = 